/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectTitle
 */
export interface ProjectTitle {
    /**
     * 
     * @type {string}
     * @memberof ProjectTitle
     */
    value: string;
}

/**
 * Check if a given object implements the ProjectTitle interface.
 */
export function instanceOfProjectTitle(value: object): value is ProjectTitle {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ProjectTitleFromJSON(json: any): ProjectTitle {
    return ProjectTitleFromJSONTyped(json, false);
}

export function ProjectTitleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectTitle {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function ProjectTitleToJSON(value?: ProjectTitle | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
    };
}

